import './App.css';
import Accolades from './components/accolades';
import Resume from './components/resume';

function App() {
  return (
    <div className="App">
      <div className="app-container">
        {/* Editorial Header */}
        <header className="app-header">
          <h1>Chan Wai Hsuen</h1>
        </header>

        {/* Single-Column Stack */}
        <main className="app-main-content">
          <Resume />
          <Accolades />
        </main>

        {/* Minimal Footer */}
        <footer className="app-footer">
          <div>&copy; {new Date().getFullYear()} Chan Wai Hsuen. All rights reserved.</div>
        </footer>
      </div>
    </div>
  );
}

export default App;
